import React from "react";
import { useSelector } from "react-redux";
import { loginData } from "../stores/auth";
import { Navigate } from "react-router-dom";
import { DASHBOARD, LOGIN, NotHaveAccess } from "../routes/routes_name";

const ProtectedRoute = ({ children, isLogin, requiredFeature }) => {
    const dataLogin = useSelector(loginData);

    // Helper function to check if user has access to a feature
    const hasFeatureAccess = (feature) => {
        if (!feature) return true; // No feature requirement
        
        const features = dataLogin?.data?.features_access_user;
        
        // If user has "all" access, allow everything
        if (features?.all) return true;
        
        if (!features) return false;

        // For nested features like "master.administrator"
        if (feature.includes('.')) {
            const [parent, child] = feature.split('.');
            return features[parent]?.[child] === true;
        }

        // For top-level features
        return features[feature] === true;
    };

    if (isLogin) {
        // User must be logged in
        if (!dataLogin.isLogin) {
            return <Navigate to={LOGIN} />;
        }

        // Check feature access if required
        if (requiredFeature && !hasFeatureAccess(requiredFeature)) {
            return <Navigate to={NotHaveAccess} />; // Redirect to default page if no access
        }

        return children;
    } else {
        // For login page, redirect if already logged in
        return !dataLogin.isLogin ? children : <Navigate to={DASHBOARD} />;
    }
};

export default ProtectedRoute;
